import Repository from './Repository'
const action = 'user'

import { preparePhone } from '@/helpers/functions'

export default {
  getUsers({ page = 1, search = {}, flag = false }) {
    let params = page ? '?page=' + page : ''

    for (let key in search) {
      if (key === 'login') {
        search[key] = preparePhone(search[key])
      }
      params += params ? '&' : '?'
      params += `${key}=${search[key]}`
    }

    if (flag) {
      params +=
        (params ? '&' : '?') + 'expand=users-organizations,organizations'
    }

    return Repository.get(action + params, { admin: true })
  },
  getAdmins() {
    return Repository.get(`${action}?role=admin`, { admin: true })
  },
  getUserToken(id) {
    return Repository.get(action + '/token/' + id, { admin: true })
  },
  deleteUser(id) {
    return Repository.delete(action + '/' + id, { admin: true })
  },
  fillByContragent(data) {
    return Repository.post(action + '/fill-by-contragent', data)
  },
}
